import { Observable } from "rxjs";
import { ITokenPair } from "../features/auth/interface/dto/token-pair";
import { IListDto } from "../interface/dto/list.dto";
import { get } from "./api";

export const searchToTrackList = (
    searchText: string,
    limit: number,
    tokens: ITokenPair,
): Observable<Array<IListDto>> =>
    get<Array<IListDto>>(
        "/lists/search-to-track",
        {
            query: searchText,
            limit,
        },
        tokens,
    );
